/**
 * Onboarding version constants
 * 
 * Increment CURRENT_ONBOARDING_VERSION when:
 * - Adding new onboarding steps
 * - Adding new features that require introduction
 * - Changing the onboarding flow significantly
 * 
 * Users with onboarding_version_completed < CURRENT_ONBOARDING_VERSION
 * will be shown the onboarding flow.
 */

export const CURRENT_ONBOARDING_VERSION = 1;

/**
 * Version history for reference:
 * v1 (Initial): Account setup
 */
